var map = {
	"./symbol_0.png": 90328,
	"./symbol_1.png": 58593,
	"./symbol_10.png": 92341,
	"./symbol_2.png": 9610,
	"./symbol_3.png": 64819,
	"./symbol_4.png": 64860,
	"./symbol_5.png": 94277,
	"./symbol_6.png": 22478,
	"./symbol_7.png": 65495,
	"./symbol_8.png": 14960,
	"./symbol_9.png": 11865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15051;